import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import { useMountedState } from 'react-use';

import { deviceType } from '../../config';

import { validateData } from '../../utils/joi';
import { successToast, warningToast } from '../../utils/toast';

import { IAppReduxState } from '../../redux/reducer';
import { authUpdateAction } from '../../redux/auth/auth.actions';

import ProductLogo from '../../components/Common/ProductLogo';
import { ButtonComp, TextInputComp } from '../../components/Forms';

import DashboardRoutes from '../Dashboard/routes';

import { Themes } from '../Users/constants';

import * as constants from './constants';
import * as utils from './utils';
import * as services from './services';

import AuthRoutes from './routes';

const DefaultFormError = {
  email: undefined,
  password: undefined,
};

function Login() {
  const isMounted = useMountedState();

  const history: any = useHistory();

  const {
    auth: {
      auth: { token: authToken },
    },
  } = useSelector((state: IAppReduxState) => state);
  const reduxActionDispatch = useDispatch();

  const [isFetching, setIsFetching] = useState(false);

  const [email, setEmail] = useState(history.location?.state?.email || '');
  const [password, setPassword] = useState('');

  const [errors, setErrors] = useState(DefaultFormError);

  useEffect(() => {
    document.body.className = 'p-0 m-0';
    return () => {
      document.body.className = '';
    };
  });

  //  Incase redirected from after 401 error or not authenticated
  useEffect(() => {
    if (!isMounted()) {
      return;
    }

    if (authToken) {
      history.push(DashboardRoutes.routes.home.path);
    }

    const warningMsg: string = history.location?.state?.warningMsg || undefined;
    const successMsg: string = history.location?.state?.successMsg || undefined;

    if (warningMsg) {
      warningToast(warningMsg);
    } else if (successMsg) {
      successToast(successMsg);
    }
  }, []);

  const formSubmitted = async (event: React.ChangeEvent<any>) => {
    event.preventDefault();

    const validate = validateData(
      { email, password },
      constants.LoginJoiScheme
    );

    if (validate.errors) {
      setErrors(validate.errors);
      return;
    }

    setIsFetching(true);
    setErrors(DefaultFormError);

    try {
      const result = await services.loginService({
        email,
        password,
        deviceType,
      });

      result.data.user = utils.formatAuthUser(result.data.user);

      //  Redux Auth Update
      reduxActionDispatch(authUpdateAction(result.data));

      //  Theme Changer Function ofr SCSS Update Parameters
      const { theme = Themes[0] } = result.data.user;

      const root = document.documentElement;
      for (const [key, value] of Object.entries(theme)) {
        root?.style.setProperty(`--${key}`, value);
      }

      //TODO THE UI may change according to the current product Kind
      // ProductUpdateDispatch({
      //   type: productActionTypes.UPDATE_PRODUCT_KIND,
      //   payload: {
      //     userProducts: result.data.user.permissions.products,
      //   },
      // });

      history.push(DashboardRoutes.routes.home.path);

      return;
    } catch (error: any) {
      console.error(error);
    }

    if (!isMounted()) {
      return;
    }
    setIsFetching(false);
  };

  return (
    <div id="wrapper">
      <div className="session-wrap login-wrap d-flex align-items-center justify-content-center justify-content-lg-end">
        <div className="session-content contact-form-wrap text-center card shadow-box">
          <ProductLogo />

          <div>
            <form onSubmit={formSubmitted}>
              <div className="form-group text-left mb-4">
                <TextInputComp
                  name="email"
                  onChange={setEmail}
                  label="Email"
                  autoFocus
                  placeholder="Email *"
                  value={email}
                  errorMsg={errors.email}
                />
              </div>

              <div className="form-group text-left mb-2">
                <TextInputComp
                  name="password"
                  type="password"
                  onChange={setPassword}
                  label="Password"
                  value={password}
                  errorMsg={errors.password}
                  placeholder="Password *"
                />
              </div>

              <div className="forgot-password-link">
                Forgot
                <Link
                  className="pull-right ml-1"
                  to={{
                    pathname: AuthRoutes.passwordForgot.path,
                    state: { email },
                  }}
                >
                  {' '}
                  Username
                </Link>{' '}
                or{' '}
                <Link
                  className="pull-right mr-1"
                  to={{
                    pathname: AuthRoutes.passwordForgot.path,
                    state: { email },
                  }}
                >
                  Password
                </Link>
                ?
              </div>

              <div className="form-group">
                <ButtonComp
                  loading={isFetching}
                  type="submit"
                  className="btn btn-one btn-block btn-primary"
                  text="Log In"
                />
              </div>

              <div className="link-register">
                <span>
                  Don’t have an account?{' '}
                  <Link
                    className="pull-left"
                    to={{
                      pathname: AuthRoutes.register.path,
                      state: { email },
                    }}
                  >
                    Register
                  </Link>
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
